import Icon from '../components/Icon.vue'

Icon.register({
  tractor: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 336C479.4 336 440 375.4 440 424S479.4 512 528 512 616 472.6 616 424 576.6 336 528 336zM528 448C514.8 448 504 437.2 504 424S514.8 400 528 400 552 410.8 552 424 541.2 448 528 448zM608 160H544V119.8C544 105.7 548.7 92 557.1 81 561.6 75.2 560.7 66.9 555.8 61.5L534.2 37.3C527.5 29.9 515.9 30.4 509.5 38.1 490.6 60.9 480 89.8 480 119.8V160H377.7L321.6 29.1A47.9-47.9 0 0 1 277.4 0H144C117.5 0 96 21.5 96 48V194.5C87.4 187.8 75 188.1 67.1 196L36 227.1C27.4 235.7 27.4 249.6 36 258.2L41.1 263.3C36.1 272.5 32.1 282.1 29.1 292H22C9.8 292 0 301.8 0 314V358C0 370.1 9.8 380 22 380H29.1C32.1 389.9 36.1 399.4 41 408.7L36 413.8C27.4 422.4 27.4 436.3 36 444.9L67.1 476C75.7 484.6 89.6 484.6 98.2 476L103.3 470.9C112.5 475.9 122.1 479.9 132 482.9V490C132 502.1 141.8 512 154 512H198C210.1 512 220 502.1 220 490V482.9C229.9 479.9 239.4 475.9 248.7 470.9L253.8 476C262.4 484.6 276.3 484.6 284.9 476L316 444.9C324.6 436.3 324.6 422.4 316 413.8L310.9 408.7C315.9 399.5 319.9 389.9 322.8 380H330C342.1 380 352 370.2 352 358V352H432.5C454.4 323 488.9 304 528 304 546.6 304 564.1 308.6 579.8 316.2L630.6 265.4C636.6 259.4 640 251.3 640 242.8V192C640 174.3 625.7 160 608 160zM176 416C131.8 416 96 380.2 96 336S131.8 256 176 256 256 291.8 256 336 220.2 416 176 416zM198 160H160V64H266.9L308 160H198z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tractor.js
// module id = SXWK
// module chunks = 144